export const isEmptyObject = (obj) => Object.keys(obj).length === 0 && obj.constructor === Object

export const arrayToObject = (array, keyField) => {
    return array.reduce((obj, item) => {
        obj[item[keyField]] = item
        return obj
    }, {})
}
